module.exports = __webpack_public_path__ + "img/icon2.1a0772a0.png";